import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import babelPolyfill from 'babel-polyfill'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views

// Users
const Users = () => import('@/views/Users/Admin')

const properties = () => import('@/views/Properties/properties_index')

const Email = () => import('@/views/Emails/email')
const EmailList = () => import('@/views/Emails/emailList')
const Whatsapp = () => import('@/views/Whatsapp/whatsapp')
const WhatsappList = () => import('@/views/Whatsapp/whatsappList')
const Fax = () => import('@/views/Fax')
const Settings = () => import('@/views/Settings')
const Profile = () => import('@/views/Profile')
const Tickets = () => import('@/views/Tickets')
const IntegrationLog = () => import('@/views/Integrations/Log')
const TicketForm = () => import('@/views/Ticket/Form')
const Integrations = () => import('@/views/Integrations/Index')
const MarketingSummary = () => import('@/views/BI/MarketingSummary')
const GoogleAnalytics = () => import('@/views/BI/GoogleAnalytics')
const Elk = () => import('@/views/BI/Elk')
const GoogleAds = () => import('@/views/BI/GoogleAds')
const SearchConsole = () => import('@/views/BI/SearchConsole')
const PSTN = () => import('@/views/BI/PSTN')

const Products = () => import('@/views/Products/Admin')
const Payments = () => import('@/views/Payments/Admin')

const Discounts = () => import('@/views/Discounts/Admin')
const RegistrationsReports = () => import('@/views/Reports/Registrations')

const AdminIntegrations = () => import('@/views/Integrations/Admin')
const AdminFirewall = () => import('@/views/Firewall/FirewallAdmin')
const UserFirewall = () => import('@/views/Firewall/FirewallUser')

const SeedlingsList = () => import('@/views/Seedlings/seedlingsList')
const Reports = () => import('@/views/Reports')

// const Trunks = () => import('@/views/Trunks')
// const TrunksAdvance = () => import('@/views/TrunksAdvance')
// const Monitoring = () => import('@/views/Monitoring')

const Voicemails = () => import('@/views/Voicemails')
const Contacts = () => import('@/views/Contacts')

const Pbxs = () => import('@/views/Pbxs')
const AdminTickets = () => import('@/views/Admin/Tickets')
const Pbx = () => import('@/views/Pbx')
const Ticket = () => import('@/views/Ticket/ticket')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')


// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')


Vue.use(Router)

const router = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})


router.beforeEach(async (to, from, next) => {

  console.log('secksession');
  await store.dispatch('checksessions');

  var status = store.state.status;
  console.log('status:'+status);
  console.log(to.path);

  if (to.path == '/register' && !status) {
    return next();
  } else if (to.path != '/login' && !status) {
    return next('/login');
  } else if (to.path == '/login' && status) {
    if([1, 14, 15].includes(store.state.data.access_level))
      return next('/admin/seedlings');
    
    return next('/get_settings');  
  } else if (to.path == '/go_to_default' && status) {
    if([1, 14, 15].includes(store.state.data.access_level))
      return next('/admin/seedlings');
    
    return next('/get_settings');  
  }else if (to.path == '/register' && status) {
    return next('/get_settings');
  }
  if (to.path.indexOf('admin') !== -1) {
    if (![1, 14, 15].includes(store.state.data.access_level)) next('/')
    next()
 }
  return next();
})



  
function configRoutes () {

  
  return [
    {
      path: '/',
      name: 'داشبورد',
      redirect: '/go_to_default',
      component: TheContainer,
      children: [
        {
          path: 'get_settings',
          name: 'setting',
          component: Settings
        },
        {
          path: 'bancheck',
          name: 'فایروال',
          component: UserFirewall,
        },
        {
          path: 'Profile',
          name: 'ویرایش پروفایل',
          component: Profile
        },
        {
          path: 'reports',
          name: 'گزارش تماس ها',
          component: Reports
        },
        {
          path: 'voicemails',
          name: 'صندوق صوتی',
          component: Voicemails
        },
        {
          path: 'contacts',
          name: 'دفترچه تلفن',
          component: Contacts
        },
        {
          path: 'fax',
          name: 'فکس',
          component: Fax
        },
        {
          path: 'Ticket',
          name: 'پشتیبانی',
          component: Tickets,
        },
        {
          path: 'Ticket/new',
          name: 'ثبت تیکت جدید',
          component: TicketForm,
        },
        {
          path: 'integrations',
          name: 'رابط برنامه نویسی',
          component: Integrations,
        },
        {
          path: 'integration/log/:prefix',
          name: 'لاگ ادغام ساز',
          component: IntegrationLog,
        },
        {
          path: 'Ticket/:prefix',
          name: 'پیگیری تیکت',
          component: Ticket
        }
      ]
    },
    {
      path: '/admin',
      name: 'مدیریت',
      redirect: 'admin/pbxs',
      component: TheContainer,
      children: [
        {
          path: 'users',
          name: 'لیست راهبران',
          component: Users
        },
        {
          path: 'bi/elk',
          name: 'زیرساخت',
          component: Elk,
        },
        {
          path: 'property',
          name: 'لیست اموال و دارایی‌ها',
          component: properties
        },
        {
          path: 'template/email',
          name: 'ایمیل',
          component: Email
        },
        {
          path: 'template/email/:prefix',
          name: 'ویرایش ایمیل',
          component: Email
        },
        {
          path: 'template/whatsapp',
          name: 'افزودن قالب واتساپ',
          component: Whatsapp
        },
        {
          path: 'template/whatsapp/:prefix',
          name: 'ویرایش قالب واتساپ',
          component: Whatsapp
        },
        {
          path: 'template/whatsapp_list',
          name: 'لیست قالب‌های واتساپ',
          component: WhatsappList
        },
        {
          path: 'template/emails',
          name: 'لیست قالب ایمیل‌ها',
          component: EmailList
        },
        {
          path: 'pbxs',
          name: 'لیست مراکز تماس ابری',
          component: Pbxs
        },
        {
          path: 'products',
          name: 'مدیریت خدمات و محصولات',
          component: Products
        },
        {
          path: 'payments',
          name: 'لیست پرداخت‌های آنلاین',
          component: Payments
        },
        {
          path: 'discounts',
          name: 'مدیریت کد‌های تخفیف',
          component: Discounts
        },
        {
          path: 'reports/registrations',
          name: 'گزارش ثبت نام‌ها',
          component: RegistrationsReports
        },
        {
          path: 'pbx/:prefix',
          name: 'لیست مراکز تماس ابری',
          component: Pbx
        },
        {
          path: 'tickets',
          name: 'لیست تیکت‌ها',
          component: AdminTickets
        },
        {
          path: 'integrations',
          name: 'رابط برنامه نویسی',
          component: AdminIntegrations,
        },
        {
          path: 'integrations/:prefix',
          name: 'رابط برنامه نویسی',
          component: AdminIntegrations,
        },
        {
          path: 'firewall',
          name: 'فایروال',
          component: AdminFirewall,
        },
        {
          path: 'integration/log/:prefix',
          name: 'لاگ ادغام ساز',
          component: IntegrationLog,
        },
        {
          path: 'seedlings',
          name: 'لیست نهال‌ها',
          component: SeedlingsList,
        },
        {
          path: 'bi/marketing_summary',
          name: 'Marketing Summary',
          component: MarketingSummary,
        },
        {
          path: 'bi/google_analytics',
          name: 'Google Analytics',
          component: GoogleAnalytics,
        },
        {
          path: 'bi/search_console',
          name: 'Search Console',
          component: SearchConsole,
        },
        {
          path: 'bi/google_ads',
          name: 'Google ads',
          component: GoogleAds,
        },
        {
          path: 'bi/pstn',
          name: 'PSTN Monitor',
          component: PSTN,
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    }
  ]
}
export default router;
